module.exports = __webpack_public_path__ + "img/door-open.d5ff59f3.svg";